import { SVGProps } from "react";

const SearchNotFound = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={58}
    height={58}
    viewBox="0 0 58 58"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M34.6267 34.6272L27.7913 27.7918M27.7913 27.7918L20.956 20.9565M27.7913 27.7918L20.956 34.6272M27.7913 27.7918L34.6267 20.9565M53.1663 53.1668L44.708 44.7085M50.7497 27.7918C50.7497 40.4714 40.4709 50.7502 27.7913 50.7502C15.1118 50.7502 4.83301 40.4714 4.83301 27.7918C4.83301 15.1123 15.1118 4.8335 27.7913 4.8335C40.4709 4.8335 50.7497 15.1123 50.7497 27.7918Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SearchNotFound;
